"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableRoundaboutIcon = PrintableRoundaboutIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableRoundaboutIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M12 0c-6.616 0-12 5.385-12 12.002s5.383 11.998 12 11.998 12-5.382 12-11.998-5.384-12.002-12-12.002zM12 22.92c-6.022 0-10.92-4.899-10.92-10.918 0-6.023 4.899-10.92 10.92-10.92s10.92 4.899 10.92 10.92c0 6.021-4.898 10.918-10.92 10.918zM8.884 6.774l1.589-2.74 1.461-0.224-1.248 2.151c2.622-0.648 5.794 0.669 6.993 3.446l-1.006 0.445c-1.116-2.29-3.442-3.333-5.738-2.809l1.894 1.638-1.527 0.171-2.418-2.078zM9.239 17.277h-3.176l-0.92-1.152h2.492c-1.873-1.939-2.317-5.341-0.516-7.767l0.894 0.64c-1.426 2.118-1.171 4.656 0.437 6.377l0.474-2.458 0.913 1.235-0.598 3.126zM18.154 11.72l1.59 2.736-0.543 1.372-1.244-2.152c-0.745 2.59-3.474 4.669-6.485 4.328l0.11-1.086c2.553 0.167 4.622-1.322 5.316-3.572l-2.367 0.823 0.612-1.407 3.010-1.043z",
    fill: color
  }));
}